import { provideZoneChangeDetection, isDevMode, importProvidersFrom } from "@angular/core";
import { registerLocaleData } from '@angular/common';
import localeId from '@angular/common/locales/id';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient } from "@angular/common/http";
import { TranslateModule } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { register } from 'swiper/element/bundle';

registerLocaleData(localeId);
register();

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(), { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)), provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideHttpClient(),

    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: 'id'
      })
    ),

    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
  ],
});
